import { computeViewLevel } from "./computeViewLevel";
import { getVisibleLayout } from "./getVisibleLayout";
/**
 * Similar to `computeVisibleLayout`, but only removes inactive attributes (viewLevel 0)
 * @param layout
 * @param attributes
 * @returns
 */
export function removeInactiveAttributes(layout, attributes) {
    // compute existing viewLevel in the layout
    const layoutWithLevels = computeViewLevel(layout, attributes.filter(isActiveAttribute));
    // removes inactive attributes (viewLevel 0)
    const visibleLayout = getVisibleLayout(layoutWithLevels, Number.MAX_SAFE_INTEGER);
    return visibleLayout;
}
function isActiveAttribute(attribute) {
    var _a;
    return (_a = (attribute.isActive && attribute.isVisible)) !== null && _a !== void 0 ? _a : false;
}
//# sourceMappingURL=removeInactiveAttributes.js.map